import { render, staticRenderFns } from "./pi-loading.vue?vue&type=template&id=49e8876d&scoped=true&"
import script from "./pi-loading.vue?vue&type=script&lang=js&"
export * from "./pi-loading.vue?vue&type=script&lang=js&"
import style0 from "./pi-loading.vue?vue&type=style&index=0&id=49e8876d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e8876d",
  null
  
)

export default component.exports